import { Injectable } from '@angular/core';
import { Globals } from '../globals';
import { PermisoService } from './permiso.service';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from './auth.service';
import { catchError } from 'rxjs/operators';
import { GeneralService } from './general.service';

@Injectable()
export class ArchivoService {
    constructor(
        private _http: HttpClient,
        private globals: Globals,
        private general: GeneralService,
        private permisoService: PermisoService,
        private _authSv: AuthenticationService,
    ) { }

    private _getHeaders(): HttpHeaders {
        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'aplication/json');
        headers = headers.set('Authorization', 'Bearer ' + this._authSv.token);
        return headers;
    }

    /**
     * En este servicio usamos HttpClient, para poder ver el progreso
     */
    cargar(model: Object): Observable<any> {
        return this._http.post(
            this.general.webserver + 'apiArchivo/cargar',
            model,
            {
                reportProgress: true,
                observe: 'events',
                headers: this._getHeaders()
            }
        ).pipe(
            catchError(() => {
                return Observable.throw('ERROR: cargando archivo');
            })
        );

    }

    descargar(model: any): Observable<any> {
        return this.permisoService.getPermisoAction('ARCHIVO-DESCARGAR')
            .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
                return this._http.post(
                    this.general.webserver + controllerAction,
                    {
                        id: model.id
                    },
                    {
                        responseType: 'arraybuffer',
                        reportProgress: true,
                        observe: 'events',
                        headers: this._getHeaders()
                    }
                ).pipe(
                    catchError(() => {
                        return Observable.throw('ERROR: descargando archivo');
                    })
                );
            });
    }
}